import "moment";

const YearQuarters = {
    getQuarter: function() {
        var quarter = {},
            month = Math.floor( ( moment().format( "MM" ) - 1 ) / 3 ) - 1;

        switch ( month ) {
            case 0:
                quarter.start = moment().month( 0 ).startOf( "month" );
                quarter.end = moment().month( 2 ).endOf( "month" );
                break;

            case 1:
                quarter.start = moment().month( 3 ).startOf( "month" );
                quarter.end = moment().month( 5 ).endOf( "month" );
                break;

            case 2:
                quarter.start = moment().month( 6 ).startOf( "month" );
                quarter.end = moment().month( 8 ).endOf( "month" );
                break;

            case 3:
                quarter.start = moment().month( 9 ).startOf( "month" );
                quarter.end = moment().month( 11 ).endOf( "month" );
                break;

            case -1:
                quarter.start = moment().subtract( 1, "year" ).month( 9 ).startOf( "month" );
                quarter.end = moment().subtract( 1, "year" ).month( 11 ).endOf( "month" );
                break;
        }

        return quarter;
    }
};

export default YearQuarters;
